export const IGetSelectedProfileUseCaseType = Symbol('IGetSelectedProfileUseCase');
